import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  stickyHeader: {
    backgroundColor: '#ffffff',
  },
}));

export default useStyles;
